var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartBeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#0052E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7799 31.7171C34.4948 31.7171 34.2404 31.8951 34.1429 32.1633L30.031 43.4707V18.1487C30.0321 17.9049 29.9017 17.6791 29.6897 17.5572C29.3642 17.3717 28.9498 17.484 28.7643 17.8095L20.8183 31.7171H9V33.0739H21.2116C21.4543 33.0739 21.679 32.9456 21.7999 32.7347L28.6742 20.7033V47.3207C28.6742 47.6504 28.9095 47.9313 29.2339 47.9896C29.2731 47.9959 29.3134 48.0002 29.3526 48.0002C29.6377 48.0002 29.8921 47.821 29.9897 47.5539L35.2548 33.075H49.7052V31.7181H34.7799V31.7171Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1151 13.8641C47.5198 11.7822 44.539 11.3868 42.4571 12.9811C40.5628 11.5278 37.8841 11.7069 36.2008 13.3998C34.351 15.2591 34.3585 18.2664 36.2177 20.1162L41.978 25.8764C42.1052 26.0036 42.2779 26.0757 42.4571 26.0757C42.6384 26.0757 42.8111 26.0025 42.9394 25.8742L48.6996 20.114C50.3861 18.4307 50.5642 15.7573 49.1151 13.8641ZM47.7371 19.1547L42.4571 24.4368L37.1771 19.1547C36.5389 18.5176 36.1817 17.6516 36.1849 16.7484C36.1902 14.8786 37.7113 13.368 39.5812 13.3744C40.4801 13.3701 41.343 13.7252 41.978 14.3613C42.243 14.6263 42.6723 14.6263 42.9373 14.3613C44.2591 13.0489 46.3898 13.0479 47.7138 14.357C49.0441 15.6757 49.0547 17.8233 47.7371 19.1547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBeat);
export default __webpack_public_path__ + "static/media/heartBeat.a4ac2e91.svg";
export { ForwardRef as ReactComponent };